import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './select';
import { Input } from './input';

const countryCodes = [
  { code: '+91', country: 'India', flag: '🇮🇳' },
  { code: '+1', country: 'USA/Canada', flag: '🇺🇸' },
  { code: '+44', country: 'UK', flag: '🇬🇧' },
  { code: '+61', country: 'Australia', flag: '🇦🇺' },
  { code: '+971', country: 'UAE', flag: '🇦🇪' },
  { code: '+65', country: 'Singapore', flag: '🇸🇬' },
  { code: '+81', country: 'Japan', flag: '🇯🇵' },
  { code: '+86', country: 'China', flag: '🇨🇳' },
  { code: '+82', country: 'South Korea', flag: '🇰🇷' },
  { code: '+49', country: 'Germany', flag: '🇩🇪' },
];

export const PhoneInput = ({ 
  value = '', 
  onChange, 
  placeholder = 'Enter 10-digit mobile number',
  required = false,
  className = '',
  countryCode = '+91',
  onCountryCodeChange,
  disabled = false
}) => {
  const handlePhoneChange = (e) => {
    const input = e.target.value;
    // Only allow digits and limit to 10 characters
    const cleaned = input.replace(/\D/g, '').substring(0, 10);
    onChange(cleaned);
  };

  // Get the selected country details
  const selectedCountry = countryCodes.find(c => c.code === countryCode) || countryCodes[0];

  return (
    <div className="relative">
      <div className={`flex gap-2 ${className}`}>
        <Select 
          value={countryCode} 
          onValueChange={onCountryCodeChange}
          disabled={disabled}
        >
          <SelectTrigger className="w-[85px]">
            <SelectValue>
              <span className="font-medium">{selectedCountry.code}</span>
            </SelectValue>
          </SelectTrigger>
          <SelectContent>
            {countryCodes.map((item) => (
              <SelectItem key={item.code} value={item.code}>
                <span className="flex items-center gap-2">
                  <span>{item.flag}</span>
                  <span>{item.code} {item.country}</span>
                </span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Input
          type="tel"
          value={value}
          onChange={handlePhoneChange}
          placeholder={placeholder}
          required={required}
          maxLength={10}
          pattern="[0-9]{10}"
          title="Please enter a valid 10-digit mobile number"
          className="flex-1"
          disabled={disabled}
        />
      </div>
      {value && value.length < 10 && (
        <span className="text-xs text-red-500 mt-1 block">
          {10 - value.length} more digits required
        </span>
      )}
    </div>
  );
};
